if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('.product-media-modal__content');
        this.boundZoomHandler = this.toggleZoom.bind(this);
        this.boundPreventClose = this.preventContentClose.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        this.bindImageZoom();
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindImageZoom();
      }

      bindImageZoom() {
        if (this.modalContent && !this.modalContent.dataset.zoomBound) {
          this.modalContent.addEventListener('pointerup', this.boundPreventClose);
          this.modalContent.dataset.zoomBound = 'true';
        }

        this.querySelectorAll('.product-media-modal__image').forEach((image) => {
          if (image.dataset.zoomBound === 'true') return;
          image.dataset.zoomBound = 'true';
          image.addEventListener('click', this.boundZoomHandler);
        });
      }

      preventContentClose(event) {
        if (event.target.closest('.product-media-modal__content')) {
          event.stopPropagation();
        }
      }

      resetZoom() {
        this.querySelectorAll('.product-media-modal__image.is-zoomed').forEach((image) => {
          image.classList.remove('is-zoomed');
          image.style.removeProperty('--zoom-origin-x');
          image.style.removeProperty('--zoom-origin-y');
        });
      }

      toggleZoom(event) {
        const image = event.currentTarget;
        const bounds = image.getBoundingClientRect();
        const xPosition = Math.min(Math.max(event.clientX - bounds.left, 0), bounds.width);
        const yPosition = Math.min(Math.max(event.clientY - bounds.top, 0), bounds.height);

        event.preventDefault();
        event.stopPropagation();

        const isZoomed = image.classList.contains('is-zoomed');
        this.resetZoom();

        if (isZoomed) return;

        image.style.setProperty('--zoom-origin-x', `${(xPosition / bounds.width) * 100}%`);
        image.style.setProperty('--zoom-origin-y', `${(yPosition / bounds.height) * 100}%`);
        image.classList.add('is-zoomed');
      }

      showActiveMedia() {
        this.resetZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
